<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width no-wrap"
      :style="{ height: '76px' }"
    >
      <span
        class="text-lg text-neutral text-weight-medium"
        :style="{ maxWidth: '75%' }"
      >
        {{ timelineHeading }}
      </span>

      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>

    <q-separator color="neutral-40" />
    <div class="q-px-2x-md q-py-xl col overflow-auto">
      <PTimeline>
        <div v-if="!props.timelines?.length">No activity yet!</div>
        <PTimelineEntry
          v-for="(timeline, index) in props.timelines"
          :key="index"
        >
          <template #default>
            <div class="text-weight-regular text-sm text-neutral">
              {{ timeline.description || "-" }}
            </div>
            <div class="text-weight-regular text-xs text-neutral-70">
              {{ formatDate(timeline.event_time, "DD MMM YYYY, h:mm a") }}
            </div>
          </template>
        </PTimelineEntry>
      </PTimeline>
    </div>
  </div>
</template>
<script setup>
import CloseIcon from "assets/icons/close.svg";

import { date } from "quasar";

const { formatDate } = date;

const { toggleTimelineDrawer } = useUserStore();
const { toggleProductTimelineDrawer } = useProductStore();

const props = defineProps({
  document: { type: String, default: "" },
  timelines: {
    type: Array,
    default: () => {
      return [];
    },
  },
  entity: { type: String, default: "" },
});

const timelineHeading = computed(() => {
  if (props.entity === "Product") {
    return `Product Timeline: ${props.document}`;
  }

  if (props.document.length) {
    return `${props.entity} Timeline: ${props.document}`;
  }

  if (props.entity === "Evaluation") {
    return "Evaluation Timeline";
  }

  return `${props.entity} Timeline`;
});

const onClose = () => {
  toggleTimelineDrawer({
    level: 0,
    open: false,
  });

  if (props.entity === "Product") {
    toggleProductTimelineDrawer({
      open: false,
    });
  }
};
</script>
